/**
 * Google Ads conversion tracking.
 *
 * window.gtag and the gtag.js load live in public/index.html, gated on window.isRoxProd, so
 * only app.roxwrite.com / appv2.roxwrite.com actually report. Outside prod the shim queues the
 * call in dataLayer and nothing ships it, which is why nothing here checks the environment.
 */

// Conversion action for a completed signup (Google Ads account AW-17707383967).
const SIGNUP_CONVERSION = 'AW-17707383967/BI_ACP7Et5kcEJ_5xPtB'

// One conversion per page load. Without this, a double-clicked submit, a React re-render or a
// retried request would each report a separate conversion and inflate the campaign numbers.
// A second genuine signup in the same tab is not a real case: both signup paths navigate away.
let signupConversionSent = false

/** Reports one completed signup. Safe to call more than once - only the first call ships. */
export const trackSignupConversion = () => {
  if (signupConversionSent) return
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  signupConversionSent = true
  window.gtag('event', 'conversion', { send_to: SIGNUP_CONVERSION })
}
